import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const PrestationsPage = lazy(() => import("../pages/prestations/page"));
const ReservationPage = lazy(() => import("../pages/reservation/page"));
const ConfirmationPage = lazy(() => import("../pages/confirmation/page"));
const VendrePage = lazy(() => import("../pages/vendre/page"));
const AcheterPage = lazy(() => import("../pages/acheter/page"));
const VehiculesPage = lazy(() => import("../pages/vehicules/page"));
const DevisPage = lazy(() => import("../pages/devis/page"));
const AdminLoginPage = lazy(() => import("../pages/admin/login/page"));
const AdminVehiculesPage = lazy(() => import("../pages/admin/vehicules/page"));
const AdminReservationsPage = lazy(() => import("../pages/admin/reservations/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const EntreprisesPage = lazy(() => import("../pages/entreprises/page"));
const ServicesAdditionnelsPage = lazy(() => import("../pages/services-additionnels/page"));
const CleanPassPage = lazy(() => import("../pages/cleanpass/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/prestations",
    element: <PrestationsPage />,
  },
  {
    path: "/reservation",
    element: <ReservationPage />,
  },
  {
    path: "/confirmation",
    element: <ConfirmationPage />,
  },
  {
    path: "/vendre",
    element: <VendrePage />,
  },
  {
    path: "/acheter",
    element: <AcheterPage />,
  },
  {
    path: "/vehicules",
    element: <VehiculesPage />,
  },
  {
    path: "/devis",
    element: <DevisPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/vehicules",
    element: <AdminVehiculesPage />,
  },
  {
    path: "/admin/reservations",
    element: <AdminReservationsPage />,
  },
  {
    path: "/entreprises",
    element: <EntreprisesPage />,
  },
  {
    path: "/services-additionnels",
    element: <ServicesAdditionnelsPage />,
  },
  {
    path: "/cleanpass",
    element: <CleanPassPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
